import { get } from "@common/services/request";
import { apiEndpoints } from "@common/constants/urls";

export const getActiveAnnouncements = () => get(apiEndpoints.announcements);
